import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

const CameraStreamFooterName = ({ footerDebugMode, gateName, direction, level, className }) => {
    const common = (
        <div className={className}>
            <p>|</p>
            <p>{gateName}</p>
            <p>|</p>
            <p>{direction}</p>
        </div>
    );

    if (footerDebugMode === 'videoWall') return;
    return (
        <Tooltip
            title={
                <div className={className}>
                    {common}
                    <p>|</p>
                    <p>{level}</p>
                </div>
            }
            placement="top-start"
        >
            <div className={className}>
                {common}
                <p>|</p>
                <p>{level}</p>
            </div>
        </Tooltip>
    );
};

CameraStreamFooterName.propTypes = {
    footerDebugMode: PropTypes.string.isRequired,
    gateName: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired,
};

export default CameraStreamFooterName;
